import { Route, Routes } from "react-router-dom";
import { NotFound } from "../../misc";
import Terms from "../components/Terms";

//component attribut will not work on v6 router version
export const TermsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
